import Eyebrow from "@/components/zeblan/Eyebrow";
import Reveal from "@/components/zeblan/Reveal";
import { LOGOS } from "@/lib/logos";

export default function OurStory() {
  return (
    <section id="our-story" className="bg-cloud py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16">
        <Reveal className="lg:col-span-6">
          <Eyebrow>Our Story</Eyebrow>
          <h2 className="mt-6 text-navy font-extrabold tracking-tightish" style={{ fontSize: "clamp(30px,4vw,46px)" }}>
            Tech expertise with a{" "}
            <span className="font-display italic font-medium text-blue">human touch</span>
          </h2>
          <div className="mt-7 space-y-5 text-slate text-[17px] leading-relaxed">
            <p className="text-[19px] text-navy/90 font-medium">
              Zeblan started with a simple observation: the tech world and the business world often struggle to speak
              the same language.
            </p>
            <p>
              Mid-sized companies hear about the incredible things AI can do, but finding a partner who actually
              understands their day-to-day operations is rare. We wanted to bridge that gap.
            </p>
            <p>
              So we built a team that's highly technical and deeply people-oriented, dedicated to making advanced AI
              approachable, secure, and genuinely useful. We believe in open communication, long-term partnerships, and
              tools your team will actually enjoy using.
            </p>
          </div>
        </Reveal>

        <Reveal delay={120} className="lg:col-span-6">
          <div className="relative rounded-2xl overflow-hidden bg-navy text-white p-8 lg:p-10 h-full">
            <img
              src={LOGOS.dark}
              alt=""
              aria-hidden
              className="absolute -right-12 -bottom-12 w-[420px] opacity-[0.06] pointer-events-none select-none"
            />
            <div className="grid sm:grid-cols-2 gap-6 relative z-10">
              <div>
                <div className="text-teal text-xs font-bold tracking-[0.22em] uppercase">The operators</div>
                <p className="mt-3 text-mist/85 text-[15px] leading-relaxed">
                  Half of us have spent years running and scaling mid-sized businesses. Managing teams, watching the
                  bottom line, fighting persistent inefficiencies.
                </p>
              </div>
              <div>
                <div className="text-teal text-xs font-bold tracking-[0.22em] uppercase">The engineers</div>
                <p className="mt-3 text-mist/85 text-[15px] leading-relaxed">
                  The other half are PhD-level researchers and engineers who've built complex systems for some of the
                  world's most advanced technology environments.
                </p>
              </div>
            </div>

            <div className="relative z-10 mt-9 pt-7 border-t border-white/10">
              <p className="font-display italic text-mist text-[22px] lg:text-[26px] leading-snug">
                “We don't just write code. We take the time to understand your culture, your bottlenecks, and your
                goals.”
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
